import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { useCatalogFetchers } from "@/shared/catalogs/hooks/useCatalogs";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

// The full catalog comes from the shared cache, so opening this picker after another one costs
// nothing. Filtering happens in the grid, which is why the search argument is no longer used.
export const useSearchDrawings = ({ setIsLoading, setError }: Props) => {
	const {
		actions: { setListAllDrawings },
	} = useTemplatesContext();
	const { fetchDocumentsCatalog } = useCatalogFetchers();

	return async (_drawingSearch?: string) => {
		setIsLoading(true);
		try {
			setListAllDrawings(await fetchDocumentsCatalog());
		} catch (e: any) {
			setError(e?.message || "Error fetching the documents catalog");
		} finally {
			setIsLoading(false);
		}
	};
};
